/* ehub Cart v1 - AJAX qty / remove / add-to-order via Shopify Cart + Section Rendering.
   No payment data handled here; checkout is standard Shopify. */
(function () {
  function root() { return document.querySelector('[data-ehcart]'); }

  function sectionId() {
    var r = root();
    return r ? r.getAttribute('data-section-id') : null;
  }

  function wrapper(id) { return document.getElementById('shopify-section-' + id); }

  // Preserve unsaved input (order note, discount code) across a section re-render.
  function snapshotInputs() {
    var snap = {};
    var note = document.querySelector('[data-cart-note]');
    var disc = document.querySelector('[data-discount-input]');
    if (note) snap.note = note.value;
    if (disc) snap.disc = disc.value;
    return snap;
  }
  function restoreInputs(snap) {
    if (!snap) return;
    var note = document.querySelector('[data-cart-note]');
    var disc = document.querySelector('[data-discount-input]');
    if (note && snap.note != null) note.value = snap.note;
    if (disc && snap.disc != null) disc.value = snap.disc;
  }

  function swapSection(html) {
    var id = sectionId();
    var el = wrapper(id);
    if (!el || !html) { window.location.reload(); return; }
    var snap = snapshotInputs();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id);
    if (fresh) { el.innerHTML = fresh.innerHTML; } else { el.innerHTML = html; }
    restoreInputs(snap);
  }

  function post(url, payload) {
    var id = sectionId();
    payload.sections = id;
    payload.sections_url = '/cart';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && data.sections[id];
        swapSection(html);
        return data;
      })
      .catch(function () { window.location.reload(); });
  }

  function changeLine(key, qty) { return post('/cart/change.js', { id: key, quantity: qty }); }
  function addVariant(vid) { return post('/cart/add.js', { id: vid, quantity: 1 }); }

  // Event delegation on the document so handlers survive section re-renders.
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest && e.target.closest('[data-qty-plus]');
    var rem   = e.target.closest && e.target.closest('[data-remove]');
    var add   = e.target.closest && e.target.closest('[data-aov-add]');
    var apply = e.target.closest && e.target.closest('[data-discount-apply]');
    if (!(minus || plus || rem || add || apply)) return;
    if (!root()) return;

    if (apply) {
      e.preventDefault();
      var input = document.querySelector('[data-discount-input]');
      var code = input ? input.value.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      return;
    }

    var lineEl = (minus || plus || rem) && (minus || plus || rem).closest('[data-line-key]');
    if (minus || plus || rem) { e.preventDefault(); if (!lineEl) return; }
    var key = lineEl ? lineEl.getAttribute('data-line-key') : null;
    var cur = lineEl ? parseInt(lineEl.getAttribute('data-qty'), 10) || 1 : 1;

    if (rem) { changeLine(key, 0); return; }
    if (minus) { changeLine(key, Math.max(0, cur - 1)); return; }
    if (plus) { changeLine(key, cur + 1); return; }
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute('data-variant-id');
      if (vid) { add.disabled = true; add.textContent = 'Added'; addVariant(vid); }
      return;
    }
  });
})();
